import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from 'mobx-react';
import * as React from 'react';
import styled from '@marvelapp/styled';
import { Box, Grid } from '@marvelapp/ui';
import { MultipleChoiceStepUtils, } from '@marvelapp/user-test-creator';
import Checkbox from '../../../slides/common/Checkbox';
import { getScreenerChoiceIcon, getScreenerChoiceStatus, getScreenerChoiceTitle, } from '../../../utils/choiceStepUtils';
import { Answer } from './Answer';
export const ScreenerAnswer = observer(function ScreenerAnswer(_a) {
    var { step, answers } = _a, restProps = __rest(_a, ["step", "answers"]);
    const selectedOptions = answers ? answers.map((a) => a.value).flat() : [];
    const multiChoiceStep = step;
    const otherOptionUUID = MultipleChoiceStepUtils.getOtherOptionUUID(multiChoiceStep);
    const choices = multiChoiceStep.choices.filter((uuid) => uuid !== otherOptionUUID);
    const otherValue = (answers === null || answers === void 0 ? void 0 : answers.length)
        ? answers[0].otherValue
        : undefined;
    return (_jsx(Answer, Object.assign({ isScreenerStep: true, step: step }, restProps, { children: _jsx(CheckboxWrapper, { children: _jsxs(Grid, { gridGap: "s", marginTop: "-4px", children: [choices.map((choiceUUID) => {
                        const choiceTitle = getScreenerChoiceTitle(multiChoiceStep, choiceUUID);
                        const choiceStatus = getScreenerChoiceStatus(multiChoiceStep, choiceUUID);
                        const choiceIcon = getScreenerChoiceIcon(multiChoiceStep, choiceUUID);
                        const screenerChoiceTitleAndStatus = `${choiceTitle} - ${choiceStatus}`;
                        return (choiceTitle && (_jsx(Checkbox, { checked: selectedOptions.includes(choiceUUID), name: screenerChoiceTitleAndStatus, readOnly: true, children: choiceIcon && (_jsx("span", { className: "inline *:mb-0.5 *:mr-1 *:inline", children: choiceIcon })) }, choiceUUID)));
                    }), otherOptionUUID && (_jsx(Checkbox, { readOnly: true, checked: selectedOptions.includes(otherOptionUUID), name: otherValue ? `Other: ${otherValue}` : 'Other' }))] }) }) })));
});
const CheckboxWrapper = styled(Box).attrs({
    maxWidth: ['100%', '100%', '50%'],
}) `
  display: inline-block;
  width: 100%;
`;
